import { api } from '../../../services/api/client';
import type { AppNotification } from '../../../types';

export interface NotificationListResponse {
  items: AppNotification[];
  unread_count: number;
}

export interface ManualSendPayload {
  target_type: 'user' | 'role' | 'all';
  user_id?: string;
  role?: string;
  title: string;
  message?: string;
  type?: string;
  send_email?: boolean;
}

const notifBase = (admin?: boolean) => (admin ? '/admin/notifications' : '/member/notifications');

export async function fetchNotifications(admin = false): Promise<NotificationListResponse> {
  const { data } = await api.get<NotificationListResponse>(notifBase(admin));
  return data;
}
export async function markNotificationRead(id: string, admin = false): Promise<AppNotification> {
  const { data } = await api.put<AppNotification>(`${notifBase(admin)}/${id}/read`);
  window.dispatchEvent(new Event('notifications:changed'));
  return data;
}
export async function markAllNotificationsRead(admin = false): Promise<any> {
  const { data } = await api.put(`${notifBase(admin)}/read-all`);
  window.dispatchEvent(new Event('notifications:changed'));
  return data;
}
export async function adminSendNotification(payload: ManualSendPayload): Promise<{ sent: number }> {
  const { data } = await api.post('/admin/notifications/send', payload);
  return data;
}


export interface BroadcastLog {
  id: string;
  title: string;
  message: string;
  type: string;
  target_type: string;
  role: string;
  sent_count: number;
  created_at: string;
}
export async function fetchBroadcasts(): Promise<BroadcastLog[]> {
  const { data } = await api.get<BroadcastLog[]>('/admin/notifications/broadcasts');
  return data;
}